// no itx for this file
import { noItx } from "../../translationItx/itx";
import Device from "../Device";
import DPTXlator from "../DPTXlator";
import jschardet from "jschardet";

export class MapValueToBuffer {
  //
  // Memory side of Mapping
  //
  fullOffset: number;
  fullBitOffset: number;
  type: string;
  sizeInBit: number;
  unionSize: number;
  parameterType: any;
  defaultValue: string;

  //
  union: any;
  baseOffset: number;
  access: string;

  //
  // Property side of Mapping
  //

  propertyId: string;
  instanceId: string;
  name: string;

  constructor(data: {
    fullOffset: number;
    fullBitOffset: number;
    type: string;
    sizeInBit: number;
    unionSize: number;
    parameterType: any;

    union: any;
    baseOffset: number;
    access: string;

    propertyId: string;
    instanceId: string;
    defaultValue: string;
    name: string;
  }) {
    this.fullOffset = data.fullOffset;
    this.fullBitOffset = data.fullBitOffset;
    this.type = data.type;
    this.sizeInBit = data.sizeInBit;
    this.unionSize = data.unionSize;
    this.parameterType = data.parameterType;
    this.defaultValue = data.defaultValue;

    this.union = data.union;
    this.baseOffset = data.baseOffset;
    this.access = data.access;

    ///////////////////////////////////////

    this.propertyId = data.propertyId;
    this.instanceId = data.instanceId;
    this.name = data.name;
  }

  putValueToBuffer(buffer: Uint8Array, device: Device, isDefaultMapping: boolean, isProductProcedure?: boolean) {
    const arr = buffer;
    const offset = this.fullOffset;
    let bitOffset = this.fullBitOffset;
    let type = this.type;
    let sizeInBit = this.sizeInBit;
    const unionSize = this.unionSize;
    const parameterType = this.parameterType;
    const parameterTypeName = this.parameterType?.a?.Id;
    const parameterName = this.name;

    // If it is DefaultMapping and one of special parameterTypes, assign default values even for ProductProcedure
    if (isDefaultMapping && isProductProcedure && !this.isSpecialParameter(parameterName)) {
      return;
    }

    let value = device.knxInstanceData.getValue(this.propertyId, this.instanceId);
    if (value === undefined || value === null || value === "") value = this.defaultValue;
    let encoding = "";
    ////////////////////////////////////////

    if (parameterType?.items.length > 0) {
      const param = parameterType.items[0];
      const paramName = param["#name"];

      if (sizeInBit == 0) {
        if (paramName == "TypeFloat") {
          type = "float";
          encoding = param.a.Encoding;
          if (encoding == "IEEE-754 Single") {
            sizeInBit = 32;
          } else if (encoding == "DPT 9") {
            sizeInBit = 16;
          } else {
            sizeInBit = 16;
          }
        } else if (paramName == "TypeText") {
          sizeInBit = parseInt(param.a.SizeInBit);
          type = "text"; // no itx
        } else if (paramName == "TypeTime" || paramName == "TypeNumber" || paramName == "TypeRestriction") {
          sizeInBit = parseInt(param.a.SizeInBit);
          type = "unsignedInt"; // no itx
        } else if (paramName == "TypeColor") {
          sizeInBit = 24; // 3 bytes each for rgb color by default
          if (param.a?.Space == "RGB" && typeof value === "string" && value.startsWith("#")) {
            // sizeInBit = 24;
            value = parseInt(value.slice(1), 16).toString();
          }
          type = "unsignedInt";
        } else {
          console.error("Unhandled Type: ", paramName);
        }

        // Unhandled:
        // "TypePicture",
        // "TypeRestriction" with Base=BinaryValue
      }
    }

    if (arr) {
      switch (type) {
        case noItx("signedInt"):
        case noItx("unsignedInt"): {
          const intValue = this.normalizeIntegerValue(value, sizeInBit, type, parameterType, parameterName);
          if (sizeInBit && sizeInBit % 8 == 0) {
            //
            // todo MWE 12.8.2024: check byte Order (Fixed)
            //
            const bytes = sizeInBit / 8;
            for (let index = 0; index < bytes; index++) {
              const a = arr[offset + index];
              arr[offset + index] = (intValue >> (8 * (bytes - 1 - index))) & 0xff;

              console.log(
                `valueToBuffer ${sizeInBit}- ${(offset + index).toString(16)}: value: ${value}, ${a} => ${arr[offset + index]?.toString(16)}`,
              );
            }
          } else if (sizeInBit && sizeInBit > 16 && sizeInBit % 8 != 0) {
            console.log(`UNHANDLED valueToBuffer: sizeInBits: ${sizeInBit}`);
          } else {
            const overflow = sizeInBit + bitOffset > 8;
            if (overflow) {
              let a = arr[offset + 1] | (arr[offset] << 8); // a is 16 Bits long !!!!!  bytes are in REVESE order

              bitOffset = 16 - sizeInBit - bitOffset;
              if (bitOffset < 0) {
                bitOffset += 8; // for handling byte overflow (rgb color)
              }

              const bitValue = intValue << bitOffset;
              let bitMask = 1; /// todo use bitssize
              for (let i = 0; i < sizeInBit - 1; i++) {
                bitMask = (bitMask << 1) | 1;
              }
              bitMask = bitMask << bitOffset;
              a = a & ~bitMask;
              a |= bitValue;

              console.log(
                `patch bit memory  value=${intValue} sizeInBit=${sizeInBit} off=${offset} bitoff=${bitOffset}  from  ${arr[offset + 1]?.toString(16)}  ${arr[offset]?.toString(16)}  `,
              );

              arr[offset + 1] = a & 0xff;
              arr[offset] = (a >> 8) & 0xff;

              console.log(`patch bit memory to  ${arr[offset + 1]?.toString(16)}  ${arr[offset]?.toString(16)}  `);
            } else {
              let a = arr[offset] | (arr[offset + 1] << 8); // a is 16 Bits long !!!!!

              bitOffset = 8 - sizeInBit - bitOffset;
              if (bitOffset < 0) {
                bitOffset += 8; // for handling byte overflow (rgb color)
              }

              const bitValue = intValue << bitOffset;
              let bitMask = 1; /// todo use bitssize
              for (let i = 0; i < sizeInBit - 1; i++) {
                bitMask = (bitMask << 1) | 1;
              }
              bitMask = bitMask << bitOffset;
              a = a & ~bitMask;
              a |= bitValue;

              console.log(
                `patch bit memory  value=${intValue} sizeInBit=${sizeInBit} off=${offset} bitoff=${bitOffset} ${arr[offset]?.toString(16)} -> ${a.toString(16)} `,
              );

              arr[offset] = a & 0xff;
            }
            // if (bitOffset + sizeInBit <= 8) {
            //   bitOffset = 8 - sizeInBit - bitOffset;
            // } else {
            //   bitOffset = 16 - sizeInBit - bitOffset;
            // }
            // let bitMask = (1 << sizeInBit) - 1;
            // bitMask <<= bitOffset;
            // const bitValue = intValue << bitOffset;
            // a &= ~bitMask;
            // a |= bitValue;

            // Handle overflow into next byte
            // if (bitOffset + sizeInBit > 8) {
            //   a1 |= a & 255;
            //   arr[offset + 1] = a1;
            //   if (a > 255) a >>= 8;
            // }
          }
          break;
        }

        case "text":
          //   for (let i = 0; i < sizeInBit / 8; i++) {
          //     const a3 = arr[offset + i];
          //     if (i < value.length) {
          //       arr[offset + i] = value.charCodeAt(i);
          //     } else {
          //       arr[offset + i] = 0;
          //     }
          //     console.log(
          //       `valueToBuffer Text- ${offset.toString(16)}:  value: ${value}, ${a3} => ${arr[offset]?.toString(16)}`,
          //     );
          //   }
          const uint8ValueArray = new TextEncoder().encode(value); // Fixes handlings for representations other than utf8 (utf16 etc.).
          for (let i = 0; i < sizeInBit / 8; i++) {
            const a3 = arr[offset + i];
            if (i < uint8ValueArray.length) {
              arr[offset + i] = uint8ValueArray[i]; //value.charCodeAt(i) This is incorrect for ut16 representations;
            } else {
              arr[offset + i] = 0;
            }
            console.log(
              `valueToBuffer Text- ${(offset + i).toString(16)}:  value: ${value}, ${a3} => ${arr[offset + i]?.toString(16)}`,
            );
          }
          break;

        case "float":
          let byteValues: Uint8Array = new Uint8Array([]);
          const intValue = parseFloat(value);
          if (sizeInBit == 32) {
            byteValues = DPTXlator.toDPT14_4ByteFloat(intValue);
          } else if (sizeInBit == 16) {
            byteValues = DPTXlator.toDPT9_2ByteFloat(intValue);
          } else {
            console.log(`valueToBuffer unhandled TypeFloat for sizeInBit ${sizeInBit}`);
            break;
          }
          const bytes = sizeInBit / 8;
          for (let index = 0; index < bytes; index++) {
            const a = arr[offset + index];
            arr[offset + index] = byteValues[index];
            console.log(
              `valueToBuffer ${sizeInBit}- ${(offset + index).toString(16)}: value: ${value}, ${a} => ${arr[offset + index]?.toString(16)}`,
            );
          }

          break;

        case "none":
          console.log(`valueToBuffer unhandled parameterType ${parameterType}`);
          break;

        default:
          console.error("type not supported", type);
      }
    }
  }

  //   getValueFromBuffer(buffer: Uint8Array): string {
  //     const offset = this.fullOffset;
  //     let bitOffset = this.fullBitOffset;
  //     let type = this.type;
  //     let sizeInBit = this.sizeInBit;
  //     const parameterType = this.parameterType;

  //     let encoding = "";
  //     let paramName = "";

  //     if (parameterType?.items.length > 0) {
  //       const param = parameterType.items[0];
  //       paramName = param["#name"];

  //       if (sizeInBit === 0) {
  //         if (paramName === "TypeFloat") {
  //           sizeInBit = 16;
  //           encoding = param.a.Encoding;
  //         } else if (paramName === "TypeText") {
  //           sizeInBit = parseInt(param.a.SizeInBit);
  //           type = "text";
  //         } else if (paramName === "TypeTime" || paramName === "TypeNumber" || paramName === "TypeRestriction") {
  //           sizeInBit = parseInt(param.a.SizeInBit);
  //           type = "unsignedInt";
  //         } else if (paramName === "TypeColor") {
  //           sizeInBit = 24;
  //           type = "unsignedInt";
  //         } else {
  //           console.error("Unhandled Type: ", paramName);
  //         }
  //       }
  //     }

  //     switch (type) {
  //       case noItx("signedInt"):
  //       case noItx("unsignedInt"): {
  //         if (sizeInBit % 8 === 0) {
  //           let result = 0;
  //           const bytes = sizeInBit / 8;
  //           for (let i = 0; i < bytes; i++) {
  //             result = (result << 8) | buffer[offset + i];
  //           }
  //           if (paramName === "TypeColor" && sizeInBit == 24) {
  //             return "#" + result.toString(16).padStart(6, "0");
  //           } else {
  //             return result.toString();
  //           }
  //         } else {
  //           // Bit-Level Reading
  //           let a = buffer[offset] | (buffer[offset + 1] << 8);
  //           let shift = 8 - sizeInBit - bitOffset;
  //           if (shift < 0) {
  //             shift += 8;
  //           }

  //           let mask = (1 << sizeInBit) - 1;
  //           mask <<= shift;

  //           const val = (a & mask) >> shift;
  //           return val.toString();
  //         }
  //       }

  //       case "text": {
  //         const byteLength = sizeInBit / 8;
  //         let result = "";
  //         for (let i = 0; i < byteLength; i++) {
  //           const code = buffer[offset + i];
  //           if (code === 0) break;
  //           result += String.fromCharCode(code);
  //         }
  //         return result;
  //       }

  //       case "none": {
  //         if (encoding === "DPT 9") {
  //           return MapValueToBuffer.fromDPT9_2ByteFloat([buffer[offset], buffer[offset + 1]]).toString();
  //         }
  //         return "0";
  //       }

  //       default:
  //         console.error("type not supported", type);
  //         return "";
  //     }
  //   }

  getValueFromBuffer(buffer: Uint8Array): any {
    const arr = buffer;
    const offset = this.fullOffset;
    let bitOffset = this.fullBitOffset;
    let type = this.type;
    let sizeInBit = this.sizeInBit;
    const parameterType = this.parameterType;
    let encoding = "";

    if (parameterType?.items.length > 0) {
      const param = parameterType.items[0];
      const paramName = param["#name"];

      if (sizeInBit == 0) {
        if (paramName == "TypeFloat") {
          type = "float";
          encoding = param.a.Encoding;
          if (encoding == "IEEE-754 Single") {
            sizeInBit = 32;
          } else if (encoding == "DPT 9") {
            sizeInBit = 16;
          } else {
            sizeInBit = 16;
          }
        } else if (paramName == "TypeText") {
          sizeInBit = parseInt(param.a.SizeInBit);
          type = "text";
        } else if (paramName == "TypeTime" || paramName == "TypeNumber" || paramName == "TypeRestriction") {
          sizeInBit = parseInt(param.a.SizeInBit);
          type = "unsignedInt";
        } else if (paramName == "TypeColor") {
          sizeInBit = 24;
          type = "unsignedInt";
        } else {
          console.error("Unhandled Type: ", paramName);
        }
      }
    }

    switch (type) {
      case noItx("signedInt"):
      case noItx("unsignedInt"): {
        let intValue = 0;

        if (sizeInBit && sizeInBit % 8 == 0) {
          const bytes = sizeInBit / 8;
          for (let i = 0; i < bytes; i++) {
            intValue = (intValue << 8) | arr[offset + i];
          }

          if (type === "signedInt") {
            const signBit = 1 << (sizeInBit - 1);
            if (intValue & signBit) {
              intValue = intValue - (1 << sizeInBit);
            }
          }

          return intValue.toString();
        } else {
          let a = arr[offset] | (arr[offset + 1] << 8);

          const isOverflow = sizeInBit + bitOffset > 8;
          if (isOverflow) {
            bitOffset = 16 - sizeInBit - bitOffset;
          } else {
            bitOffset = 8 - sizeInBit - bitOffset;
          }

          if (bitOffset < 0) {
            bitOffset += 8;
          }

          let bitMask = (1 << sizeInBit) - 1;
          const value = (a >> bitOffset) & bitMask;
          return value.toString();
        }
      }

      case "text": {
        const byteLength = sizeInBit / 8;
        const textBytes = arr.slice(offset, offset + byteLength);
        // return new TextDecoder().decode(textBytes).replace(/\0+$/, ""); // Strip nulls
        return this.decodeWithDetection(textBytes).replace(/\0+$/, ""); // Strip nulls
      }

      case "float": {
        const floatBytes = arr.slice(offset, offset + sizeInBit / 8);

        if (sizeInBit === 32) {
          return DPTXlator.fromDPT14_4ByteFloat(floatBytes);
        } else if (sizeInBit === 16) {
          return DPTXlator.fromDPT9_2ByteFloat(floatBytes);
        } else {
          console.warn(`Unhandled float sizeInBit: ${sizeInBit}`);
          return null;
        }
      }

      case "none":
        console.warn(`getValueFromBuffer unhandled parameterType ${parameterType}`);
        return null;

      default:
        console.error("getValueFromBuffer: type not supported", type);
        return null;
    }
  }

  private normalizeIntegerValue(
    rawValue: any,
    sizeInBit: number,
    type: string,
    parameterType: any,
    parameterName: string,
  ): number {
    if (typeof rawValue === "boolean") return rawValue ? 1 : 0;

    let normalized = rawValue;
    if (typeof normalized === "string") {
      const trimmed = normalized.trim();
      if (trimmed === "") return 0;
      if (/^(true|on|yes)$/i.test(trimmed)) return 1;
      if (/^(false|off|no)$/i.test(trimmed)) return 0;
      if (/^0x[0-9a-f]+$/i.test(trimmed)) normalized = parseInt(trimmed.slice(2), 16);
      else if (/^-?\d+(\.\d+)?$/.test(trimmed)) normalized = Number(trimmed);
      else {
        const enumValue = this.resolveRestrictionValue(trimmed, parameterType);
        if (enumValue !== undefined) normalized = enumValue;
      }
    }

    let intValue = Number(normalized);
    if (!Number.isFinite(intValue)) {
      console.warn(`[MapValueToBuffer] Falling back to 0 for ${parameterName}; unsupported value`, rawValue);
      intValue = 0;
    }

    intValue = Math.trunc(intValue);

    if (sizeInBit > 0) {
      if (type === noItx("signedInt")) {
        const min = -(2 ** (sizeInBit - 1));
        const max = 2 ** (sizeInBit - 1) - 1;
        intValue = Math.max(min, Math.min(max, intValue));
      } else {
        const max = 2 ** Math.min(sizeInBit, 31) - 1;
        intValue = Math.max(0, Math.min(max, intValue));
      }
    }

    return intValue;
  }

  private resolveRestrictionValue(rawValue: string, parameterType: any): number | undefined {
    const items = parameterType?.items || [];
    for (const item of items) {
      const values = item?.items || [];
      for (const enumItem of values) {
        const enumValue = enumItem?.a?.Value;
        const enumText = enumItem?.a?.Text;
        const enumId = enumItem?.a?.Id;
        if (
          [enumText, enumId].some(
            (candidate) => typeof candidate === "string" && candidate.toLowerCase() === rawValue.toLowerCase(),
          )
        ) {
          const parsed = Number(enumValue);
          if (Number.isFinite(parsed)) return parsed;
        }
      }
    }
    return undefined;
  }

  isSpecialParameter(parameterName: string): boolean {
    const specialParams = [
      "pm.extOnFallbackTime",
      "pm.extOffFallbackTime",
      "pm.brightnessThresholdSave",
      "pm.followUpTimeValueSaveDay_0",
      "pm.followUpTimeValueSaveNight_0",
      "LUM.teachinReset",
    ];
    return specialParams.some((name) => parameterName.includes(name));
  }

  decodeWithDetection(bytes: Uint8Array): string {
    // Convert Uint8Array to binary string
    let binaryString = "";
    for (let i = 0; i < bytes.length; i++) {
      binaryString += String.fromCharCode(bytes[i]);
    }

    // Detect encoding
    const detection = jschardet.detect(binaryString);
    const encoding = detection.encoding?.toLowerCase() || "utf-8";

    // Use TextDecoder to decode original bytes
    const decoder = new TextDecoder(encoding as any, { fatal: false });
    return decoder.decode(bytes);
  }
}
